import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

export default function ClientCardAllowed() {
	return hasSoftDeployAccess('REACT_CLIENT_CARD');
}
